import React from 'react';

type Props = {};
const Space = () => <div style={{ height: 10 }} />;

export default function TermsAndConditionsContent({}: Props) {
  return (
    <div>
      These Terms & Conditions apply to the Services (set forth below) offered on the Nippon Travel Agency Co., Ltd. (hereinafter NTA) website and the
      rights and obligations between NTA and the registered users of the Services (the “Members”).
      <Space />
      <b>
        Please read these Terms & Conditions carefully before using the Services. Your registration and use of the Services are conditioned upon your
        agreement to and acceptance of the Terms & Conditions herein.
      </b>
      <Space />
      Members should save and/or print a copy of these Terms & Conditions for future reference.
      <Space />
      {/*  */}
      {/* ------------1---------- */}
      {/*  */}
      <div className="fw-500 text-18 py-10">1. Applicability of the Terms & Conditions </div>
      These Terms & Conditions (the "The Terms & Conditions") shall apply to the offering and the providing of the NTA online booking services, such
      as the booking of accommodation and activities (the " Services") offered by NTA on the NTA Website.
      <Space />
      Any rules for use of the Services posted on the NTA Website shall constitute an integral part of the Terms & Conditions.
      <Space />
      If there is any individual agreement between a Member and NTA executed separately, such individual agreement will always supersede the Terms &
      Conditions. <br />
      If there is any provision not stated in the "individual agreement" that has been concluded between NTA and a member, however, the provision of
      the Terms & Conditions will be applied on a priority basis. <br />
      {/*  */}
      {/* -----------2----------- */}
      {/*  */}
      <div className="fw-500 text-18 py-10">2. Forbidden Usage</div>
      On NTA Hotel /Tour Online Booking, the Members are NOT entitled to make the following booking:
      <Space />
      (i) Group booking: Group booking means booking four (4) rooms or more for the same date and same property by the one Member.
      <Space />
      (ii) Potential future booking : Potential future booking means booking without the names of the individual traveler, such as booking under a
      company name and/or using the same name multiple times.
      <Space />
      Please note that NTA reserves the right to cancel or refuse to accept bookings within category (i) and/or (ii) above.
      {/*  */}
      {/* -----------3----------- */}
      {/*  */}
      <div className="fw-500 text-18 py-10">3. Confirmation from NTA</div>
      (i) Hotel Online Booking: Confirmation of a booking, which includes the essential elements such as the description of the Services booked and
      the price, will be sent to the Members immediately after the booking is made online by e-mail. If the Members do not receive a confirmation
      e-mail, the Members should contact [omega_support@nta.co.jp] indicating the reservation number.
      <Space />
      (ii) Activity Online Booking: Confirmation of a booking, which includes the essential elements such as the description of the Services and the
      price, will be sent to the Members after booking is completed by e-mail. If the Members do not receive a confirmation e-mail, the Members should
      contact [miyabi_support@nta.co.jp] indicating the reservation number.
      {/*  */}
      {/* -----------4----------- */}
      {/*  */}
      <div className="fw-500 text-18 py-10">4. Cancellation</div>
      The Members may cancel the reservations at any time by following method.
      <Space />
      (i) Hotel Online Booking: by clicking on the booking confirmation page of NTA website.
      <Space />
      (ii) Activity Online Booking: by cancellation on the reservation page or by e-mail to NTA.
      <Space />
      In the event of a cancellation or partial cancellation of a booking by the Members, cancellation charges may be imposed according to the
      cancellation policy outlined at the time of booking. Where a cancellation affects more than one person on the booking, any applicable
      cancellation charge will be applied with respect to each person on the booking.
      <Space />
      All changes and cancellations will be resolved with Japanese Standard Time. For changes and cancellations please contact NTA during regular
      business hours. In the event of changes or cancellations made outside of business hours, charges will be assessed based on the next business
      day.
      {/*  */}
      {/* -----------5----------- */}
      {/*  */}
      <div className="fw-500 text-18 py-10">5. Payment</div>
      Members are required to pay the amount indicated on the confirmation in Japanese Yen no later than 14 days prior to the date of the service.
      Payments can be made by bank transfer or credit card. If booking is made on or after 14 days prior to the date of service, members must pay the
      amount indicated on the confirmation at the time of booking.
      <Space />
      If a member fails to pay the specified amount within the deadline, NTA may immediately cancel any subsequent reservations under the same member
      account. Additionally, the member will be required to pay any applicable cancellation fees to NTA.
      {/*  */}
      {/* -----------6----------- */}
      {/*  */}
      <div className="fw-500 text-18 py-10">6. Notification from NTA</div>
      NTA shall from time to time send necessary notifications to the Members by posting them on the NTA website and/or by sending an E-mail to the
      Members. When posted on NTA's website or sent by E-mail, such notifications shall come into force at the time of their posting or sending
      whichever is applicable.
      {/*  */}
      {/* -----------7----------- */}
      {/*  */}
      <div className="fw-500 text-18 py-10">7. Registration for the Services</div>
      A Person desiring to use the Services must register to use the Services and become a Member by agreeing to comply with these Terms & Conditions
      and providing essential, accurate and truthful information as specified on the NTA Website at the time of registration. Registration information
      shall be applied to the Services offered on the NTA Website.
      <Space />
      Members shall promptly notify NTA of any change to the registration information in accordance with such manner as prescribed by NTA.
      <Space />
      Members, who have registered and use the Services, are limited to any person or authorized representative that operates within a licensed travel
      agency.
      {/*  */}
      {/* -----------8----------- */}
      {/*  */}
      <div className="fw-500 text-18 py-10">8. Password and Member ID</div>
      Members are required to establish their passwords and member IDs for the Service offered on the NTA website. Members shall be responsible for
      keeping and maintaining their password and member IDs for the Services in an appropriate manner, and may not be used by a third party, or
      provide, transfer, change the name of, sell or otherwise dispose of the same.
      <Space />
      The Members shall be, and NTA shall in no event be, liable for damages arising out of inappropriate management, misuse, or use of the Members’
      passwords or IDs by a third party.
      {/*  */}
      {/* -----------9----------- */}
      {/*  */}
      <div className="fw-500 text-18 py-10">9. Use Environment </div>
      Members shall be responsible for the system environment required for the use of the Services at their own expense and responsibility, including
      but not limited to, any hardware, software, telephone lines and so forth.
      <Space />
      Under no circumstances shall NTA be liable for any damages whatsoever incurred by the Members arising out of discontinuance, suspension,
      unavailability of the Services, cancellation or loss of messages or information transmitted by the Members or NTA to the other party, loss of
      registered data, or failure of or damage to equipment through the use of the Services or otherwise in connection with the Services.
      {/*  */}
      {/* -----------10----------- */}
      {/*  */}
      <div className="fw-500 text-18 py-10">10. Prohibitions </div>
      The Members are prohibited from conducting any of the following acts or any act that NTA determines falls under any of the following:
      <Space />
      (i) Acts that infringe on, or have the risk of infringing on the copyrights, property rights, privacy or other rights of another Member, a third
      party or NTA;
      <Space />
      (ii) In addition to the previous paragraph, acts that result in, or have the risk of resulting in a disadvantage or damages to another Member, a
      third party or NTA;
      <Space />
      (iii) Acts that defraud or threaten other Members, other third parties or NTA;
      <Space />
      (iv) Acts that violate, or have the risk of violating the public morality, or actions of providing information that violates the public morality
      to another Member or a third party;
      <Space />
      (v) Acts that are criminal or associated with criminal actions, or have the risk of such;
      <Space />
      (vi) Acts of an election campaign or similar thereto, regardless of whether or not during an election period;
      <Space />
      (vii) Activities relating to sexual practices, religion or politics;
      <Space />
      (viii) Acts that have as their object, or are preparatory to the object of profiting from the use of the Services through their use without
      permission from NTA;
      <Space />
      (ix) Acts involving the improper use of log-in IDs and/or passwords;
      <Space />
      (x) Acts of using or providing malicious software, including computer viruses, through or related to the Services;
      <Space />
      (xi) Acts to impersonate a third party;
      <Space />
      (xii) Acts that place an excessive burden on the network or system of the Services
      <Space />
      (xiii) Acts of exploitation, advertisement, soliciting or marketing without NTA’s prior consent;
      <Space />
      (xiv) Acts that violate, or have the risk of violating a law or ordinance; or
      <Space />
      (xv) Other acts that NTA deems to be inappropriate.
      {/*  */}
      {/* -----------11----------- */}
      {/*  */}
      <div className="fw-500 text-18 py-10">11. Termination of Membership </div>
      A Member may terminate their membership from the Services for any reason. NTA shall accept the termination through a process separately
      provided.
      <Space />
      NTA reserves the right to make the Member withdraw from the Services without prior notice and to refuse re-registration from such Member:
      <Space />
      (i) where a Member uses the Services in a way violating the Terms & Conditions;
      <Space />
      (ii) where a Member uses the Services in an improperly or illegally manner; or
      <Space />
      (iii) where the registration information provided by the Member is found to be false, inaccurate or omitted.
      <Space />
      Upon the termination of the membership, all amounts then due and payable from the Member, if any, shall be automatically accelerated and the
      Member shall immediately pay to NTA such amount in full.
      {/*  */}
      {/* -----------12----------- */}
      {/*  */}
      <div className="fw-500 text-18 py-10">12. Prohibition of Assignment</div>
      The Members may not assign, transfer, grant security interests in or otherwise dispose of its status or the rights or obligations under the
      Terms & Conditions to any third party without prior written consent of NTA.
      {/*  */}
      {/* -----------13----------- */}
      {/*  */}
      <div className="fw-500 text-18 py-10">13. System Modifications </div>
      Should NTA determine that changes to the system or content specific to the operations of the Services or registration are required, NTA shall
      make such required changes without prior notification.
      {/*  */}
      {/* -----------14----------- */}
      {/*  */}
      <div className="fw-500 text-18 py-10">14. Suspension of the Services</div>
      NTA shall be entitled to, without any advance notice to the Members, suspend or discontinue the Services in whole or in part, if:
      <Space />
      (i) Hotel / Activity Online Booking carries out regular or emergency maintenance or inspection for the system of the Services: Hotel / Tour
      Online Booking regular maintenance is performed every Tuesday 00:00～07:30(Japan Time) and when Monday is national public holiday in Japan, the
      maintenance is performed at the same time on Wednesday;
      <Space />
      (ii) Computers or communication lines have been disrupted due to force majeure, including but not limited to, war, riot, terrorism, fighting,
      unrest, labor struggles, earthquakes, volcanic eruptions, flooding, tidal waves, lightning, fires, power outages and the like; or
      <Space />
      (iii) NTA determines that a temporary suspension or discontinuance in the operations of the Services is required for other reasons.
      <Space />
      Under no circumstances shall NTA be liable for any damages incurred by the Members arising out of any measures taken by NTA under the Article 13
      and Article 14 hereof.
      {/*  */}
      {/* -----------15----------- */}
      {/*  */}
      <div className="fw-500 text-18 py-10">15. Members’ Personal Information </div>
      NTA shall appropriately maintain the registration information given by Members, and shall comply with the Personal Information Privacy Policies
      set forth by NTA.
      <Space />
      NTA shall not disclose the registration information given by the Members through the process of Services. Provided, however, that guest
      information may be disclosed:
      <Space />
      (i) When the Member has agreed to the disclosure of personal information;
      <Space />
      (ii) When disclosure is required by law; or
      <Space />
      (iii) When NTA discloses statistical personal information (exclusive of information that could identify an individual) gathered in order to
      analyze of the Services. Please check our web for more details.{' '}
      <a href="https://www.ntainbound.com/policy/privacy_policy.htm" target="_blank">
        https://www.ntainbound.com/policy/privacy_policy.htm
      </a>
      {/*  */}
      {/* -----------16----------- */}
      {/*  */}
      <div className="fw-500 text-18 py-10">16. Disclaimer and Waiver of Warranties</div>
      NTA makes no representation or warranty of any kind, expressed or implied, concerning the Services, including but not limited to any
      representation or warranty (i) of fitness or suitability for a particular purpose contemplated by the Members, (ii) that the Services have
      expected functions, commercial value, accuracy, or usefulness, (iii) that the use by the Member of the Services complies with the laws and
      regulations applicable to the Member, and (iv) that the Services will be free of interruption or defect(s).
      <Space />
      NTA shall not in any way be liable for transaction, communication or disputes arising between the Member and other Member or a third party in
      connection with the Services or NTA Website.
      {/*  */}
      {/* -----------17----------- */}
      {/*  */}
      <div className="fw-500 text-18 py-10">17. Amendment of the Terms & Conditions</div>
      NTA reserves the right to modify, amend or change these Terms & Conditions from time to time without the prior consent of the Members. In the
      event of any amendment or change to the Terms & Conditions, NTA shall notify the Members thereof by posting on the NTA Website.
      <Space />
      Such amendment or change to the Terms & Conditions shall come into force upon posting on the NTA Website. If Members use the Services on or
      after posting the amendment or change on NTA Website, the Members shall be deemed to have agreed to such amendment or change to these Terms &
      Conditions.
      {/*  */}
      {/* -----------18----------- */}
      {/*  */}
      <div className="fw-500 text-18 py-10">18. Severability</div>
      If any provision of the Terms & Conditions or part hereof is held to be invalid or unenforceable under the applicable laws or regulations, the
      remaining provisions hereof shall remain in full force and effect.
      {/*  */}
      {/* -----------19----------- */}
      {/*  */}
      <div className="fw-500 text-18 py-10">19. Governing Law and Jurisdiction </div>
      The Terms & Conditions shall be governed by the laws of Japan.
      <Space />
      Any disputes arising out of or in connection with the Terms & Conditions and/or the Services shall be submitted to the exclusive jurisdiction of
      the Tokyo District Court or the Tokyo Summary Court in Japan, depending on the case.
      <Space />
      Effective Date of the Terms & Conditions:
      <Space />
      The Terms & Conditions shall take effect on August 1st, 2024, Japan standard time.
      <div style={{ marginTop: 50 }}>
        <h5>NIPPON TRAVEL AGENCY CO., LTD.</h5>
        <h6>Inbound Travel Department</h6>
        <b>4th floor, Yotsuya TN Bldg,16-1 Samoncho Shinjuku-ku, Tokyo 160-0017 JAPAN</b>
      </div>
    </div>
  );
}
